import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class RoomMoveReport extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'created_at',
    'reservation_id',
    'reservation_ident',
    'guest_name',
    'guest_last_name',
    'previous_room_type',
    'new_room_type',
    'previous_room',
    'new_room',
    'user_name',
)(RoomMoveReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/daily-activity/room-move.model.js